import { createAction } from '@reduxjs/toolkit';

export const tipUpdateId = createAction('tip/updateId');
export const tipUpdateUID = createAction('tip/updateUid');
export const tipUpdateSID = createAction('tip/updateSid');
export const tipUpdateIsAdded = createAction('tip/updateIsAdded');
export const tipUpdateIsActive = createAction('tip/updateIsActive');

export const tipStore = createAction('tip/store');
export const tipClear = createAction('tip/clear');

export const tipUpdateRequest = createAction('tip/updateRequest');
export const tipUpdateError = createAction('tip/updateError');
export const tipUpdateStore = createAction('tip/updateStore');

export const tipUpdateItems = createAction('tip/updateItems');

export const tipUpdateButtonTitle = createAction('tip/updateButtonTitle');
export const tipUpdateButtonBackgroundColor = createAction('tip/updateButtonBackgroundColor');
export const tipUpdateButtonTextColor = createAction('tip/updateButtonTextColor');
export const tipUpdateMessage = createAction('tip/updateMessage');
export const tipUpdateView = createAction('tip/updateView');

export const tipUpdateThemeColor = createAction('tip/updateThemeColor');
export const tipUpdateThemeTextColor = createAction('tip/updateThemeTextColor');

export const tipUpdateHeadingTitle = createAction('tip/updateHeadingTitle');
export const tipUpdateHeadingDescription = createAction('tip/updateHeadingDescription');
export const tipUpdateHeadingTextAlign = createAction('tip/updateHeadingTextAlign');
export const tipUpdateHeadingImage = createAction('tip/updateHeadingImage');
export const tipUpdateHeadingDivider = createAction('tip/updateHeadingDivider');

export const tipUpdateSectionIsBackground = createAction('tip/updateSectionIsBackground');
export const tipUpdateSectionTextColor = createAction('tip/updateSectionTextColor');
export const tipUpdateSectionBackgroundColor = createAction('tip/updateSectionBackgroundColor');
export const tipUpdateSectionOpacity = createAction('tip/updateSectionOpacity');
export const tipUpdateSectionIsFullWidth = createAction('tip/updateSectionIsFullWidth');
export const tipUpdateSectionShadow = createAction('tip/updateSectionShadow');
export const tipUpdateSectionShadowColor = createAction('tip/updateSectionShadowColor');
export const tipUpdateSectionPadding = createAction('tip/updateSectionPadding');
export const tipUpdateSectionMargin = createAction('tip/updateSectionMargin');
export const tipUpdateSectionBackgroundType = createAction('tip/updateSectionBackgroundType');
export const tipUpdateSectionBackgroundImage = createAction('tip/updateSectionBackgroundImage');
export const tipUpdateSectionGradientColor1 = createAction('tip/updateSectionGradientColor1');
export const tipUpdateSectionGradientColor2 = createAction('tip/updateSectionGradientColor2');
export const tipUpdateSectionGradientDirection = createAction('tip/updateSectionGradientDirection');
export const tipUpdateSectionGradientOffset = createAction('tip/updateSectionGradientOffset');
export const tipUpdateSectionBorder = createAction('tip/updateSectionBorder');
export const tipUpdateSectionBorderColor = createAction('tip/updateSectionBorderColor');
export const tipUpdateSectionShadowBorderColor = createAction('tip/updateSectionShadowBorderColor');
export const tipUpdateSectionShape = createAction('tip/updateSectionShape');
